module.exports = __webpack_public_path__ + "img/sSweetLava_350x350.0665a3a9.jpg";